import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TopNav from '@/pages/home/components/TopNav';
import Footer from '@/pages/home/components/Footer';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <TopNav />
      <main className="flex-grow pt-16 md:pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
}